import React from 'react';
export function Footer() {
  return <footer className="bg-base text-muted py-12 border-t border-surface" data-id="element-127">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-128">
        <h4 className="text-white font-bold text-xl mb-4" data-id="element-129">
          ☢️ MEGAPACK ENERGÍA NUCLEAR LISTO™
        </h4>

        <p className="mb-6 text-sm leading-relaxed" data-id="element-130">
          Hecho por especialistas, para docentes de Física y Ciencias de toda
          Argentina.
          <br data-id="element-131" />
          <strong className="text-electric mt-2 block" data-id="element-132">
            🇦🇷☢️ "La próxima clase que des, podés entrar al aula sabiendo que
            Argentina tiene la historia nuclear más rica de América Latina."
          </strong>
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-133">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-white transition-colors" data-id="element-134">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline" data-id="element-135">·</span>
          <span className="hover:text-white transition-colors" data-id="element-136">
            📱 @centralpack.ar
          </span>
        </div>

        <div className="text-xs text-muted/50 border-t border-surface pt-8" data-id="element-137">
          <p className="mb-2" data-id="element-138">
            © MEGAPACK ENERGÍA NUCLEAR LISTO™ 2026 — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}